import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgSuccess(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#00A674" />
      <path
        fill="white"
        d="M14.0252 22.6834L24.983 11.7255L22.5775 9.31995L14.0238 17.8737L10.1018 13.9516L7.69763 16.3558L14.0252 22.6834Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSuccess);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
